// extracted by css-extract-rspack-plugin
module.exports =  {"tileLayout":"xdjIL","loader":"TQ5Hx","spin":"gJD7a","col2":"o043b","toiPlusHeading":"ACT2n"};